import React, { useState } from 'react'
import './Header.css'
import Logo from '../../assets/logo.png'
import Bars from '../../assets/bars.png'
import { Link } from 'react-scroll'

const Header = () => {

  const mobile = window.innerWidth <= 768;
  const [menuOpened, setMenuOpened] = useState(false);

  const handleLinkClick = () => {
    setTimeout(() => setMenuOpened(false), 200); // Delay closing menu to complete scroll
  }

  return (
    <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      
      {/* Logo on the left side */}
      <img src={Logo} alt="" className='logo' />

      {/* Bars Icon (right side on mobile) */}
      {mobile && !menuOpened && (
        <div
          style={{
            backgroundColor: "var(--appColor)",
            padding: '0.5rem',
            borderRadius: '5px',
            position: 'absolute',
            right: '1rem'
          }}
          onClick={() => setMenuOpened(true)}
        >
          <img src={Bars} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
        </div>
      )}

      {/* Menu Items */}
      {(menuOpened || !mobile) && (
        <ul className='header-menu' style={mobile ? { position: 'absolute', top: '3.5rem', right: '1rem', backgroundColor: 'var(--appColor)', padding: '1rem', borderRadius: '5px' } : {}}>
          <li>
            <Link to='home' spy={true} smooth={true} onClick={handleLinkClick}>Home</Link>
          </li>
          <li>
            <Link to='programs' spy={true} smooth={true} onClick={handleLinkClick}>Programs</Link>
          </li>
          <li>
            <Link to='reasons' spy={true} smooth={true} onClick={handleLinkClick}>Why Us</Link>
          </li>
          <li>
            <Link to='plans' spy={true} smooth={true} onClick={handleLinkClick}>Plans</Link>
          </li>
          <li>
            <Link to='Testimonials' spy={true} smooth={true} onClick={handleLinkClick}>Testimonials</Link>
          </li>
        </ul>
      )}
    </div>
  )
}

export default Header
